const p = {
  0: "0",
  0.25: "2px",
  0.5: "4px",
  0.75: "6px",
  1: "8px",
  2: "16px",
  2.25: "18px",
  3: "24px",
  4: "32px",
  5: "40px",
  6: "48px",
  7: "56px",
  8: "64px",
  9: "72px"
};
export {
  p as spaces
};
